import { Component, OnInit, Input } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-task-selector-comp',
  templateUrl: './task-selector.component.html',
  styleUrls: ['./task-selector.component.scss'],
})
export class TaskSelectorComponent implements OnInit {
  @Input() path: string = '';
  @Input() text: string = '';
  @Input() image: string = '';
  constructor(private router: Router) {}

  ngOnInit(): void {
    //this.router.navigate(['/sales-realization']);
  }

  ontaskSelect() {
    this.router.navigate([this.path]);
  }
}
